import {
  Collection1k04j3hzsbod0 as Collection,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  HashMap1a0ld5kgwhmhv as HashMap,
  toMutableList20rdgwi7d3cwi as toMutableList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Unit_instanceat14thlj150z as Unit_instance,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  addAll21mdhg523wnoa as addAll,
  KtMutableList1beimitadwkna as KtMutableList,
  AbstractList3ck35puwbp1e9 as AbstractList,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  AbstractMutableList192xfq8ycgofs as AbstractMutableList,
  copyToArray2j022khrow2yi as copyToArray,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  joinToStringxqcavsxcmh4q as joinToString,
  protoOf180f3jzyo7rfj as protoOf,
  RandomAccess1jbw8sdogqb8x as RandomAccess,
} from './kotlin-kotlin-stdlib.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class DoubleList {}
function getAt(index) {
  return this.h1(index);
}
function toDoubleArray() {
  var tmp = 0;
  var tmp_0 = this.g1();
  var tmp_1 = new Float64Array(tmp_0);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = this.h1(tmp_2);
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function listIterator() {
  return this.k1(0);
}
function listIterator_0(index) {
  return this.q1(index, this.g1()).b3();
}
function subList(fromIndex, toIndex) {
  return SimpleSubList(fromIndex, toIndex, DoubleList$subList$lambda(this));
}
function containsAll(elements) {
  return containsAllCheck(this, elements);
}
function isEmpty() {
  return this.g1() === 0;
}
function iterator() {
  return this.b3();
}
class Mixin {
  constructor(extra) {
    extra = extra === VOID ? null : extra;
    this.b28_1 = extra;
  }
  c28(_set____db54di) {
    this.b28_1 = _set____db54di;
  }
  d28() {
    return this.b28_1;
  }
}
class Property {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.e28_1 = name;
    this.f28_1 = defaultGen;
  }
}
class PropertyThis {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.g28_1 = name;
    this.h28_1 = defaultGen;
    var tmp = this;
    tmp.i28_1 = Extra$PropertyThis$transform$lambda;
  }
}
class ExtraObject {
  constructor() {
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.j28_1 = get_atomicfu$reentrantLock();
    this.k28_1 = HashMap.a9();
    var tmp_0 = this;
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'korlibs.datastructure.ExtraObject.values.<anonymous>' call
    tmp_0.l28_1 = toMutableList(this.k28_1.n3());
  }
  g1() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-size>.<anonymous>' call
    return this.k28_1.g1();
  }
  u1() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>' call
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = this.k28_1.f3();
    var result = LinkedHashMap.xc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = this.k28_1.e3(element);
      result.k3(element, tmp$ret$0);
    }
    return toMutableSet(toMutableMap(result).u1());
  }
  f3() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-keys>.<anonymous>' call
    return toMutableSet(this.k28_1.f3());
  }
  n3() {
    return this.l28_1;
  }
  cj(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'korlibs.datastructure.ExtraObject.get.<anonymous>' call
    return this.k28_1.e3(key);
  }
  e3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.cj((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  m28(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    this.k28_1.k3(key, value);
    return Unit_instance;
  }
  n28(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'korlibs.datastructure.ExtraObject.contains.<anonymous>' call
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.k28_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(key);
  }
  j1() {
    return this.g1() === 0;
  }
  h3() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    this.k28_1.h3();
    return Unit_instance;
  }
  o28(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'korlibs.datastructure.ExtraObject.remove.<anonymous>' call
    return this.k28_1.l3(key);
  }
  l3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.o28((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  p28(from) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.u1().b1();
    while (_iterator__ex2g4s.c1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.d1();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.v1();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.w1();
      // Inline function 'kotlin.collections.set' call
      this.k28_1.k3(key, value);
    }
    return Unit_instance;
  }
  m3(from) {
    return this.p28(from);
  }
  q28(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    this.k28_1.k3(key, value);
    return Unit_instance;
  }
  k3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.q28(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  m1j(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.j28_1;
    // Inline function 'korlibs.datastructure.ExtraObject.containsKey.<anonymous>' call
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.k28_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(key);
  }
  c3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.m1j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
}
class MutableListEx {}
function setAddAll(index, elements, offset, size) {
  // Inline function 'kotlin.math.min' call
  var b = this.g1() - index | 0;
  var setCount = Math.min(size, b);
  this.y28(index, elements, offset, setCount);
  this.z28(elements, offset + setCount | 0, size - setCount | 0);
}
function setAddAll$default(index, elements, offset, size, $super) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? elements.g1() - offset | 0 : size;
  var tmp;
  if ($super === VOID) {
    this.x28(index, elements, offset, size);
    tmp = Unit_instance;
  } else {
    setAddAll(index, elements, offset, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setAll(index, elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.i3(index + n | 0, elements.h1(offset + n | 0));
    }
     while (inductionVariable < size);
}
function addAll_0(elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.h(elements.h1(offset + n | 0));
    }
     while (inductionVariable < size);
}
function removeToSize(size) {
  this.p7(size, this.g1());
}
class SimpleSubList$1 extends AbstractList {
  static d29($toIndex, $fromIndex, $get, $box) {
    if ($box === VOID)
      $box = {};
    $box.a29_1 = $toIndex;
    $box.b29_1 = $fromIndex;
    $box.c29_1 = $get;
    return this.sj($box);
  }
  g1() {
    return this.a29_1 - this.b29_1 | 0;
  }
  h1(index) {
    if (!(0 <= index ? index < this.g1() : false))
      throw IndexOutOfBoundsException.ye();
    return this.c29_1(index + this.b29_1 | 0);
  }
}
class Fixed {
  constructor(value) {
    this.e29_1 = value;
  }
  f29() {
    return this.e29_1;
  }
  toString() {
    return 'Fixed(value=' + toString(this.e29_1) + ')';
  }
  hashCode() {
    return hashCode(this.e29_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fixed))
      return false;
    var tmp0_other_with_cast = other instanceof Fixed ? other : THROW_CCE();
    if (!equals(this.e29_1, tmp0_other_with_cast.e29_1))
      return false;
    return true;
  }
}
class FastArrayList extends AbstractMutableList {
  static g29(__array) {
    var $this = this.m7();
    $this.s28_1 = __array;
    return $this;
  }
  static u28() {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.g29(tmp$ret$0);
  }
  static t28(initialCapacity) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.g29(tmp$ret$0);
  }
  g1() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.s28_1.length;
  }
  h1(index) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.s28_1[rangeCheck(this, index)];
  }
  i3(index, element) {
    rangeCheck(this, index);
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = this.s28_1[index];
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FastArrayList.set.<anonymous>' call
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    this.s28_1[index] = element;
    return this_0;
  }
  h(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.s28_1.push(element);
    this.y6_1 = this.y6_1 + 1 | 0;
    return true;
  }
  n7(index, element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.s28_1.splice(insertionRangeCheck(this, index), 0, element);
    this.y6_1 = this.y6_1 + 1 | 0;
  }
  i1(elements) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    return _addAll(this, tmp$ret$0);
  }
  j3(index) {
    rangeCheck(this, index);
    this.y6_1 = this.y6_1 + 1 | 0;
    var tmp;
    if (index === 0) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.s28_1.shift();
    } else if (index === get_lastIndex(this)) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.s28_1.pop();
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.s28_1.splice(index, 1)[0];
    }
    return tmp;
  }
  g3(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.s28_1;
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = array[index];
        if (equals(tmp$ret$4, element)) {
          array.splice(index, 1);
          this.y6_1 = this.y6_1 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  p7(fromIndex, toIndex) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.s28_1.splice(fromIndex, toIndex - fromIndex | 0);
    this.y6_1 = this.y6_1 + 1 | 0;
  }
  h3() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.s28_1.length = 0;
    this.y6_1 = this.y6_1 + 1 | 0;
  }
  q7(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.s28_1.indexOf(element);
  }
  toString() {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = this.s28_1;
    return '[' + joinToString(tmp$ret$4, ', ') + ']';
  }
  o8() {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.s28_1.concat();
  }
  toArray() {
    return this.o8();
  }
}
//endregion
function DoubleList$subList$lambda(this$0) {
  return function (it) {
    return this$0.h1(it);
  };
}
function Extra$PropertyThis$transform$lambda(_this__u8e3s4, it) {
  return it;
}
function getExtra(_this__u8e3s4, name) {
  var tmp3_safe_receiver = _this__u8e3s4.d28();
  return tmp3_safe_receiver == null ? null : tmp3_safe_receiver.cj(name);
}
function setExtra(_this__u8e3s4, name, value) {
  if (_this__u8e3s4.d28() == null) {
    if (value == null)
      return Unit_instance;
    _this__u8e3s4.c28(ExtraTypeCreate());
  }
  var tmp4_safe_receiver = _this__u8e3s4.d28();
  if (tmp4_safe_receiver == null)
    null;
  else {
    tmp4_safe_receiver.m28(name, value);
  }
}
function hasExtra(_this__u8e3s4, name) {
  var tmp2_safe_receiver = _this__u8e3s4.d28();
  return (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.n28(name)) === true;
}
function getExtraTyped(_this__u8e3s4, name) {
  var tmp = _this__u8e3s4.d28();
  var tmp1_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e3(name);
}
function ExtraTypeCreate() {
  return new ExtraObject();
}
function fastArrayListOf(values) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.t28(values.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.fastArrayListOf.<anonymous>' call
  addAll(this_0, values);
  return this_0;
}
function toFastList(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.t28(_this__u8e3s4.g1());
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toFastList.<anonymous>' call
  // Inline function 'korlibs.datastructure.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.g1()) {
    // Inline function 'korlibs.datastructure.toFastList.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = _this__u8e3s4.h1(_unary__edvuaz);
    this_0.h(it);
  }
  return this_0;
}
function toFastList_0(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.t28(_this__u8e3s4.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toFastList.<anonymous>' call
  // Inline function 'korlibs.datastructure.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.length) {
    // Inline function 'korlibs.datastructure.toFastList.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = _this__u8e3s4[_unary__edvuaz];
    this_0.h(it);
  }
  return this_0;
}
function toFastList_1(_this__u8e3s4, out) {
  out = out === VOID ? FastArrayList.u28() : out;
  out.v28(0, _this__u8e3s4);
  out.w28(_this__u8e3s4.g1());
  return out;
}
function SimpleSubList(fromIndex, toIndex, get) {
  return SimpleSubList$1.d29(toIndex, fromIndex, get);
}
function containsAllCheck(collection, elements) {
  var elementsMap = toMutableSet(elements);
  var _iterator__ex2g4s = collection.b1();
  while (_iterator__ex2g4s.c1()) {
    var v = _iterator__ex2g4s.d1();
    elementsMap.g3(v);
  }
  return elementsMap.j1();
}
function Resourceable(value) {
  return new Fixed(value);
}
function _addAll($this, elements) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (elements.length === 0)
    return false;
  // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = $this.s28_1;
  (function () {
    var $externalVarargReceiverTmp = tmp$ret$3;
    return $externalVarargReceiverTmp.push.apply($externalVarargReceiverTmp, [].slice.call(elements.slice()));
  }.call(this));
  $this.y6_1 = $this.y6_1 + 1 | 0;
  return true;
}
function rangeCheck($this, index) {
  if (index < 0 || index >= $this.g1())
    throw IndexOutOfBoundsException.ze('index: ' + index + ', size: ' + $this.g1());
  return index;
}
function insertionRangeCheck($this, index) {
  if (index < 0 || index > $this.g1())
    throw IndexOutOfBoundsException.ze('index: ' + index + ', size: ' + $this.g1());
  return index;
}
//region block: post-declaration
initMetadataForInterface(DoubleList, 'DoubleList', VOID, VOID, [Collection]);
initMetadataForClass(Mixin, 'Mixin', Mixin);
initMetadataForClass(Property, 'Property');
initMetadataForClass(PropertyThis, 'PropertyThis');
initMetadataForClass(ExtraObject, 'ExtraObject', ExtraObject, VOID, [KtMutableMap]);
initMetadataForInterface(MutableListEx, 'MutableListEx', VOID, VOID, [KtMutableList]);
initMetadataForClass(SimpleSubList$1);
initMetadataForClass(Fixed, 'Fixed', VOID, VOID, VOID, [0]);
protoOf(FastArrayList).z28 = addAll_0;
protoOf(FastArrayList).x28 = setAddAll;
protoOf(FastArrayList).v28 = setAddAll$default;
protoOf(FastArrayList).y28 = setAll;
protoOf(FastArrayList).w28 = removeToSize;
initMetadataForClass(FastArrayList, 'FastArrayList', FastArrayList.u28, VOID, [AbstractMutableList, MutableListEx, RandomAccess]);
//endregion
//region block: exports
export {
  containsAll as containsAll1oa5i6t9xmbdv,
  getAt as getAt237u54ctbxwvd,
  isEmpty as isEmptyrqh4vz39e0v6,
  iterator as iterator300ls4j24zqzz,
  listIterator as listIterator247sl90ooi4qv,
  listIterator_0 as listIterator1a2ckgeamf7jc,
  subList as subList28p829u9d5w23,
  DoubleList as DoubleList2honu8rif2roh,
  Mixin as Mixin3lmkm5hum2vdj,
  PropertyThis as PropertyThis2r0hbk1cs09wj,
  Property as Property1m5vulkepgwzd,
  ExtraTypeCreate as ExtraTypeCreate3a0hrg4tu0473,
  FastArrayList as FastArrayListw5fr1wlp4slq,
  fastArrayListOf as fastArrayListOf1rdodhrpn0q8y,
  getExtraTyped as getExtraTyped8zexqxz5xxli,
  getExtra as getExtra307y0o9pd6mp3,
  hasExtra as hasExtra1969mplo13qgb,
  setExtra as setExtra314k0z6q35eku,
  toFastList_1 as toFastList1btvvxvv57pw,
  toFastList as toFastList32ukjb68l6wd7,
  toFastList_0 as toFastListzo2jtkrx0z5y,
  Resourceable as Resourceable38whwgli3ts8g,
};
//endregion
